/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum JobDataMappedFilter {
    ALL = 'all',
    MAPPED = 'mapped',
    UNMAPPED = 'unmapped',
}
